const zh = {
	aqqewad:'安全密码需6-20位',
	qsrzz: '请输入整数',
	黄金: '黄金',
	美元: '美元',
	原油: '原油',
	数值: '数值',
	caijinj: '彩金',
	djlfjj: '提交认证',
	sutfufk: '认证码将发送至您的邮箱',
	hoafaa: '发送认证码',
	reqawao: '邮箱认证',
	renzyao: '认证要求',
	weirenzz: '未认证',
	dhjzg: 'L1 认证',
	shiabais: '提现失败',
	chongzzi: '充值失败',
	zhengsong: '赠送',
	shouyi: '收益',
	chenggong: '成功',
	lunm: '轮',
	mmcuowu: '密码不正确',
	qmiia: '安全密码必须是6位数字',
	至尊: '至尊',
	贵宾: '贵宾',
	专业: '专业',
	普通: '普通',
	基础: '基础',
	gunqq: '成功',
	fwwq: '复制失败',
	fuz: '复制成功',
	shangpin: '上传凭证',
	fuzz: '复制',
	erwei: '二维码',
	pipeii: '请输入地址',
	pipei: '匹配地址',
	shuruu: '输入金额',
	touzichenggong: '投资成功',
	tzjebndyzhye: '投资金额不能大于账户余额',
	tzjebnxy: '投资金额不能小于1',
	qxztzlx: '请选择投资类型',
	shurujine: '输入金额',
	huiyuan: '会员',
	moshi: '模式',
	touzi: '投资',
	zhtz: '组合投资',
	lsjl: '历史记录',
	lunjieguo: '轮 结果',
	sycj: '剩余时间',
	jxz: '进行中',
	ljcj: '立即储值',
	tzze: '投资总额',
	yffje: '已发放金额',
	zxrs: '在线人数',
	涨: '涨',
	大涨: '大涨',
	小涨: '小涨',
	跌: '跌',
	大跌: '大跌',
	小跌: '小跌',
	tjiao: '提交',
	xuaze: '选择头像',
	textee21: '传送国际电子邮件至support-gold@fgold.org',
	textee20: '意见与投诉：',
	textee19: '问题解答：请联系国际在线客服',
	textee18: 'Forex Gold USA的团队将不懈努力为使您能得到一切所需资讯，以便更好地探索、使用我们的平台，将其带给您带来的收益最大化。 如果用户仍有任何问题，都可以随时与我们联络。',
	textee17: '每一个用户对我们来说都是最重要的。',
	textee16: '联系我们',
	textee15: '4.操作的隐蔽性和灵活性',
	textee14: '3.筹资方式的私募性',
	textee13: '2.投资效应的高回报性',
	textee12: '1.投资活动的便捷性',
	textee11: '特点：',
	textee10: '作为业内的国际领军企业之一，Forex Gold USA已在全球赢得30多项享有盛誉的奖项。无论是在成熟市场，还是新兴市场，凭借我们的创新及服务，Forex Gold USA的领先地位每一年都在不断加强。',
	textee9: '为了客户能获得超凡的交易体验，Forex Gold USA也为每一位参与交易的客户进行了盈利的长期不定时的更新平台优化建设。Forex Gold USA为全球来自110多个国家的用户提供优质服务。',
	textee8: 'Forex Gold USA是一款便捷、隐蔽、高回报的投资交易软件，量子基金投资20亿美元联合纽约证券交易所（USA），纳斯达克证券交易所（NASDAQ），伦敦证券交易所（LDN）等数十个全球各大交易所，通过数据挖掘，对各大期货商品交易的加权平均值做计算衍生的黄金、美金、原油投资产品，通过预期买涨、买跌、大涨、大跌、小涨、小跌等操作来进行个人投资行为。截止2023年12月，Forex Gold USA的全球用户数超过5543万，平均回报率约为29.30%。',
	textee7: 'Forex Gold USA',
	textee6: '4.原油和大豆，糖等：得克萨斯原油、杜伦特原油。',
	textee5: '3.黄金白银等贵金属：伦敦金、铂金、钯金、银、铜、等等贵金属交易。',
	textee4: '2.外汇：美元对人民币（离岸人民币），欧元/美元、欧元/日元、欧元/纽元、英镑/美元、美元/日元、美元/加元等等24小时。',
	textee3: '2013年4月1日纳斯达克斥资7.5亿美元（约58.5亿港元）现金，向货币经纪商BGC Partners收购电子债券交易平台eSpeed，令纳市可首次涉足每日交投量达5000亿美元的市场，若收入符合目标，纳斯达克将在未来15年发行价值4.84亿美元的约1500万股普通股，使这项交易的潜在价值达到12.3亿美元。',
	textee2: '1.指数期货：纳斯达克、德国法兰克福指数、法国CAC-40指数、欧盟50指数、日经指数、香港恒生国企指数、ASX 200指数、瑞典股票30等，美元指数USDOLLAR，香港恒生指数、道琼斯工业指数、伦敦富时100、标准普尔500、所有产品可以申请模拟',
	textee1: 'Forex Gold USA是一家为投资黄金、美金、原油实时国际价涨跌组合金融投资业务的著名环球交易服务供应商。集团成立于1997年，20多年来始终如一地经营自己的诚信品牌，以良好的声誉与优质的服务成为全球投资者的首选。Forex Gold USA通过纳斯达克、美国、伦敦、国际金融中心提供同步数据给于用户不同的方式以专业不同的品类交易的视角为全球不同国家地区用户提供一切需要的图表及数据，让全球不同国家地区的用户轻松的随时进行交易。0点差、每日推送交易信号、良好的交易体验让Forex Gold USA荣获全世界30多项交易大奖，成为全世界超5543万的用户的交易首选。',
	anquan1: '修改安全密码',
	touzijl: '投资记录',
	yirenz: '已认证',
	ldn5: '最终LDN的20170508001轮结果为：7+4+5=16（涨）（小涨）',
	ldn4: 'LDN采集英国伦敦证券交易所等数十个全球各大交易所，通过数据挖掘，对各大期货商品交易的加权平均值做计算衍生的黄金、美金、原油投资产品的国际实时价格波动涨跌值，时间全体24小时，每5分钟赋值更新一轮，投资模式为6种组合简便投资模式，分别归类与黄金、美金、原油三种价格波动值组合结果为（0-13）为跌，（14-27）为涨，（0-6）为大跌，（7-13）为小跌，（14-20）为小涨，（21-27）为大涨。',
	ldn3: 'LDN投资说明：',
	ldn2: 'LDN是英国伦敦证券交易所等数十个全球各大交易所，通过数据挖掘，对各大期货商品交易的加权平均值做计算衍生的黄金、美金、原油投资产品的国际实时价格波动涨跌值组合AQ的投资结果每5分钟的加权平均值换算出的结果，最终结果换算为三个（0－9）的数字之和，总共有28种结果（0－27）。',
	ldn1: 'LDN是什么',
	usa5: '最终USA的20170508001轮结果为：7+4+5=16（涨）（小涨）',
	usa4: 'USA采集美国纽约证券交易所等数十个全球各大交易所，通过数据挖掘，对各大期货商品交易的加权平均值做计算衍生的黄金、美金、原油投资产品的国际实时价格波动涨跌值，时间全体24小时，每3分钟赋值更新一轮，投资模式为6种组合简便投资模式，分别归类与黄金、美金、原油三种价格波动值组合结果为（0-13）为跌，（14-27）为涨，（0-6）为大跌，（7-13）为小跌，（14-20）为小涨，（21-27）为大涨。',
	usa3: 'USA投资说明：',
	usa2: 'USA是美国纽约证券交易所等数十个全球各大交易所，通过数据挖掘，对各大期货商品交易的加权平均值做计算衍生的黄金、美金、原油投资产品的国际实时价格波动涨跌值组合AQ的投资结果每3分钟的加权平均值换算出的结果，最终结果换算为三个（0－9）的数字之和，总共有28种结果（0－27）。',
	usa1: 'USA是什么',
	nasd9: '最终NASDAQ的20170508001轮结果为：7+4+5=16（涨）（小涨）',
	nasd8: '2017年5月8日09：05计算原油涨跌数据赋予的值为：5',
	nasd7: '2017年5月8日09：05计算出美金涨跌数据赋予的值为：4',
	nasd6: '2017年5月8日09：05计算出黄金涨跌数据赋予的值为：7',
	nasd5: '例如：',
	nasd4: 'NASDAQ采集纳斯达克证券交易所等数十个全球各大交易所，通过数据挖掘，对各大期货商品交易的加权平均值做计算衍生的黄金、美金、原油投资产品的国际实时价格波动涨跌值，时间全体24小时，每1分钟赋值更新一轮，投资模式为6种组合简便投资模式，分别归类与黄金、美金、原油三种价格波动值组合结果为（0-13）为跌，（14-27）为涨，（0-6）为大跌，（7-13）为小跌，（14-20）为小涨，（21-27）为大涨。',
	nasd3: 'NASDAQ投资说明：',
	nasd2: 'NASDAQ是纳斯达克证券交易所等数十个全球各大交易所，通过数据挖掘，对各大期货商品交易的加权平均值做计算衍生的黄金、美金、原油投资产品的国际实时价格波动涨跌值组合AQ的投资结果每1分钟的加权平均值换算出的结果，最终结果换算为三个（0－9）的数字之和，总共有28种结果（0－27）。',
	nasd1: 'NASDAQ是什么',
	text10: '账户等级越高，投资回报率将会随之越高；',
	text9: '账户等级分为基础级，普通级，专业级，贵宾级，至尊级；',
	text8: '投资100美金小跌，最终的结果为小跌，则回报率为360美金；',
	text7: '投资100美金大跌，最终的结果为大跌，则回报率为360美金；',
	text6: '投资100美金小涨，最终的结果为小涨，则回报率为360美金；',
	text5: '投资100美金大涨，最终的结果为大涨，则回报率为360美金；',
	text4: '投资100美金跌，最终的结果为跌，则回报率为195美金；',
	text3: '投资100美金涨，最终的结果为涨，则回报率为195美金；',
	text2: '投资（涨），（跌），（大涨），（小涨），（大跌），（小跌）',
	text1: '低风险组合投资回报率说明',
	ldn: '什么是 LDN ？',
	usa: '什么是 USA ？',
	nasd: '什么是 NASDAQ ？',
	text: '投资规则说明',
	xitongxx: '系统消息',
	touzimx: '投资明细',
	youxiao: '请输入有效的邮箱地址',
	liangan: '两次安全密码输入不一致',
	liang: '两次密码输入不一致',
	qsryz: '请输入正确的数字验证码',
	tianxx: '请务必填写好本人邮箱，否则无法正常通过验证',
	yanzhengma: '请输入验证码',
	youxiang: '邮箱',
	anquanmi: '确认安全密码',
	anquan: '请输入安全密码',
	querenmma: '确认密码',
	tijiao: '提交',
	meyou: '沒有账号',
	zaixian: '在线客服',
	deglu: '登录',
	jichu: '基础',
	putong: '普通',
	zhuanye: '专业',
	guibin: '贵宾',
	chaoguibin: '至尊',
	jiaoyidating: '交易',
	zuiditouzi: '最低金额',
	zuidijinru: '进入标准',
	anquanzhongxin: '安全中心',
	renzhengzx: '认证中心',
	jiaoyiguize: '交易规则',
	jinrisunyi: '今日损益',
	zican: '资产',
	anquanma: '安全密码',
	hangqing: '行情',
	jiaoyi: '交易',
	qianbao: '钱包',
	jiantizhongwen: '简体中文',
	xianlu: '线路',
	dianwei: '当前点位',
	wodezichan: '我的资产',
	touzikuaixun: '投资快讯',
	jiaoyiyonghu: '交易用户',
	jiaoyipinglei: '交易品类',
	danlunhuoli: '单轮获利',
	jiaoyiriqi: '交易日期',
	dengluhouchakan: '登陆后查看',
	shouye: '首页',
	yucun: '预存',
	zoushi: '走势',
	wode: '我的',
	jichulicai: '基础理财',
	zishenlicai: '资深理财',
	dashilicai: '大师理财',
	zhuanjialicai: '专家理财',
	基础理财: '基础理财',
	资深理财: '资深理财',
	大师理财: '大师理财',
	专家理财: '专家理财',
	huiyuanquanyi: '会员权益',
	zuoriyingli: '昨日盈利',
	zongzichan: '总资产',
	chucunjin: '储存金',
	jinriyingli: '今日盈利',
	zhuanchu: '提现',
	cunru: '充值',
	zhanghuxinxni: '账户信息',
	lishizhangdan: '历史账单',
	zijinminxi: '资金明细',
	renwuzhongxin: '任务中心',
	xiaoxigonggao: '消息公告',
	tuijianfenxiang: '推荐分享',
	huodongzhongxin: '活动中心',
	jibenziliao: '基本资料',
	dengluzhanghao: '登录账号',
	nicheng: '昵称',
	shezhi: '设置',
	genggaixianlu: '更改线路',
	guanyuwomen: '关于我们',
	xitongshezhi: '系统设置',
	yuyanshezhi: '语言设置',
	tuichudenglu: '退出登录',
	bangdingyinhangka: '绑定银行卡',
	bangdingxuniqianbao: '绑定虚拟钱包',
	// anquanma: '安全码',
	xiugailenglumima: '修改登陆密码',
	yinhangkaguanli: '银行卡管理',
	tianjiayinhangka: '添加银行卡',
	xuniqianbaoguanli: '虚拟钱包管理',
	tianjiaxuniqianbao: '添加虚拟钱包',
	chiakren: '持卡人',
	yinhangkakahao: '银行卡卡号',
	yinhangmingcheng: '银行名称',
	yhkTps: '请绑定持卡人本人的银行卡',
	nixiqianbaodizhi: '虚拟钱包地址',
	xuniqianbaoleixing: '虚拟钱包类型',
	xnqbTps: ' 温馨提示：请填写USDT地址类型，如：trc20、erc20、omni ',
	plchikaren: '请输入持卡人',
	plkahao: '请输入持卡人卡号',
	plyinhangmingcheng: '请输入银行名称',
	plqbdz: '请输入虚拟钱包地址',
	plqblx: '请输入虚拟钱包类型',
	shezhianquanma: '设置安全码',
	yuananquanma: '原安全码',
	xinanquanma: '新安全码',
	planquanma: '请输入原安全码',
	plxinanquanma: '請输入新安全码',
	queren: '确认',
	quxiao: '取消',
	anquanmaTps: ' 请设置安全码，请勿与银行卡密码相同',
	anquanmaTpsTow: ' 尊敬的客户，此安全码是您转出时的密码，为了安全起见，请尽量不要与登录密码相同',
	xiugaidenglu: '修改登录密码',
	jiumima: '旧密码',
	xinmima: '新密码',
	querenmima: '确认密码',
	pljiumima: '请输入旧密码',
	plxinmima: '请输入新密码',
	plquerenmima: '请再次输入密码',
	wancheng: '完成',
	kaishitouzi: '开始投资',
	kaiTps: '当前线路无法使用时，可尝试切换其他线路',
	zuiyou: '最优',
	dangaqianxianlu: '当前线路',
	dangqianbanben: '2025年新用户活动彩金派送中，拥有活动名额用户可注意查收系统消息',
	banquansuoyou: '版权所有',
	yinglizhendong: '盈利震动',
	gensuixitong: '跟随系统',
	zhuanchujine: '转出金额',
	plzhuanchu: '请输入转出金额',
	zhuanchuTps: '温馨提示：如有疑问请联系平台客服。',
	xuanzeyh: '请选择提款银行卡',
	xuanzehb: '请选择提款虚拟钱包',
	tijiaoshenqing: '提交申请',
	shuruanquanma: '请输入安全码',
	xianshangcunru: '线上存入',
	saomacunru: 'USDT',
	wangyincunru: "银行存入",
	shijian: '时间',
	upshijian: '开始时间',
	downshijian: '结束时间',
	wuTps: '暂无相关数据~',
	jiazaicx: '重新加载',
	di: '第',
	lun: '轮',
	weiyingli: '未盈利',
	yishouli: '已受理',
	zhuangtai: '状态',
	chongzhi: '重置',
	riqi: '日期',
	CapActive: {
		chongzhi: '充值',
		tixian: '提现',
		goumai: '购买',
		yingli: '盈利',
		zengsong: '赠送',
		weitongguo: '未通过',
		yitongguo: '已通过',
		yijujue: '已拒绝',
	},
	zhanneixiaoxi: "站内消息",
	pingtaigonggao: '平台公告',
	fuzhilanjie: "复制链接",
	denglu: '登录',
	zhuce: '注册',
	jizhumima: '记住密码',
	wangjimima: '忘记密码',
	youkedenglu: '游客登陆',
	zhucezhanghao: "注册账户",
	plusername: '请输入用户名',
	plpassword: '请输入密码',
	wanchengzhuce: '完成注册',
	yiyouzhanghao: '已有账户',
	qingdenglu: '请登录',
	remenhuati: '热门话题',
	news1: '原创',
	news2: '推荐',
	news3: '财富',
	renliulan: '人浏览',
	hezhi: '和值',
	lunshu: '轮数',

	做多: '做多',
	做空: '做空',
	多单: '多单',
	多双: '多双',
	空单: '空单',
	空双: '空双',
	平单: '平单',
	平双: '平双',
	极阴: '极阴',
	极阳: '极阳',
	qi: '期',
	juli: '距离',
	lunjiezhi: '轮截至',
	yifengpan: '已封盘',
	yiguanbi: '已关闭',
	yonghu: '用户',
	danlunjiaoyi: '单轮交易',
	caozuo: '操作',
	pljoin: '加入聊天室成功',
	pltingshou: '产品已停售',
	gengou: "跟购",
	quedinggengou: "确定跟购吗",
	wanjia: "玩家",
	leibie: "类别",
	jine: "金额",
	gouru: '购入',
	zanweigouru: '暂未购入',
	qigou: '起购',
	gourushuliang: '购入数量',
	changgui: '常规',
	shuzi: '数字',
	yinglihezhi: '盈利和值',
	shouyijieshao: '收益介绍',
	lijicunru: '立即存入',
	kaihaojieguo: '开号结果',
	kaihaoqushi: '开号趋势',
	chanpingshuoming: '产品说明',
	qingchuhuancun: '清除缓存',
	youke: '游客',
	gongxi: '恭喜 ',
	zai: ' 在 ',
	yingli: ' 盈利 ',
	xiadanchenggong: '下单成功',
	jiazaizhong: '加载中...',
	guanbitg: '已关闭，停止购入',
	xiangoudl: '只能跟购当前轮',
	liaotiantip: '系统已禁言，请选择购入',
	tishi: '提示',
	zhidao: '知道了',
	zhuanchusb: '转出失败',
	zhuanchusbs: '余额不足，转出失败',
	buyxq: '购入详情',
	orderNo: '账单编号',
	plan_name: '厅房信息',
	buyxx: '购入信息',
	haoxx: '选号详情',
	buysj: '购入时间',
	yilou: '遗漏',
	fzjqb: '已复制到粘贴板',
	chanpin1: '开售时间：每3.5分钟为一轮，当日10:00AM开盘，次日02:00AM停盘。',
	chanpin2: '每轮有3个0-9的数字，3个数字相加为最终结果，可以投资结果做多做空平单平双极阳极阴以及数字。',
	Tips: {
		wjmm: '忘记密码请联系客服修改!',
		dlcg: '登录成功',
		tjcg: '提交成功',
		zanwu: '暂无数据',
		buyizhi: '两次密码不一致',
		zcbz: '您的资产不足请存入',
		pltxje: '请输入提现金额',
		zdtx: '最低提现100',
		youke: '尊敬的游客您好：请您注册正式会员后操作。',
		szcg: '设置成功',
	},
}
export default zh;